import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const pains = ['No sabés si el precio que piden es el real o está inflado', 'No podés detectar si el auto fue chocado aunque te lo juren', 'No sabés si el kilometraje es real o fue adulterado', 'Los papeles te confunden y firmás sin entender qué', 'No tenés argumentos para negociar y pagás lo que piden', 'Comprás y al mes aparece el primer problema que el vendedor sabía'];
export function PainSection() {
  return <section className="pt-14 pb-0 relative overflow-hidden" data-id="element-404">
      <div className="absolute top-0 left-0 w-full h-2 hazard-tape" data-id="element-405"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-406">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto mb-12" data-id="element-407">
          {/* Outer red glow */}
          <div className="absolute -inset-1 bg-gradient-to-r from-electric via-red-400 to-electric rounded-3xl blur-xl opacity-40 animate-pulse" data-id="element-408"></div>

          {/* Frame */}
          <div className="relative bg-gradient-to-br from-graphite via-petroleum to-graphite border-2 border-electric rounded-3xl p-8 md:p-10 text-center overflow-hidden shadow-2xl shadow-electric/30 bg-brushed" data-id="element-409">
            {/* Grid pattern background */}
            <div className="absolute inset-0 opacity-[0.10] pointer-events-none" style={{
            backgroundImage: 'linear-gradient(rgba(217,30,24,0.7) 1px, transparent 1px), linear-gradient(90deg, rgba(217,30,24,0.7) 1px, transparent 1px)',
            backgroundSize: '24px 24px'
          }} data-id="element-410"></div>

            {/* Corner accents */}
            <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-electric rounded-tl-3xl pointer-events-none" data-id="element-411"></div>
            <div className="absolute top-0 right-0 w-16 h-16 border-t-4 border-r-4 border-electric rounded-tr-3xl pointer-events-none" data-id="element-412"></div>
            <div className="absolute bottom-0 left-0 w-16 h-16 border-b-4 border-l-4 border-electric rounded-bl-3xl pointer-events-none" data-id="element-413"></div>
            <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-electric rounded-br-3xl pointer-events-none" data-id="element-414"></div>

            <div className="relative z-10" data-id="element-415">
              <div className="inline-flex items-center gap-2 bg-electric text-white px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-5 shadow-lg shadow-electric/40" data-id="element-416">
                <XCircle className="w-3.5 h-3.5" data-id="element-417" />
                El Problema Real
              </div>
              <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-418">
                ¿Cuánto más vas a postergar la compra por miedo a que te{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-electric via-red-400 to-electric drop-shadow-[0_0_12px_rgba(217,30,24,0.4)]" data-id="element-419">
                  estafen?
                </span>
              </h2>
              <div className="mx-auto h-px w-32 bg-gradient-to-r from-transparent via-electric to-transparent opacity-70 mb-4" data-id="element-420"></div>
            </div>
          </div>
        </motion.div>

        <div className="max-w-4xl mx-auto grid gap-4 md:grid-cols-2" data-id="element-421">
          {pains.map((pain, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-petroleum p-5 rounded-xl border border-electric/10 flex items-start gap-4 hover:border-electric/30 transition-colors" data-id="element-422">
              <XCircle className="w-6 h-6 text-electric shrink-0 mt-0.5" data-id="element-423" />
              <span className="text-textsecondary" data-id="element-424">{pain}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}